import { callApi } from '@/api/apibase'

export const getOrderStatusByCourseId  = function (customersCourseId) {
    return callApi('GET', `/api/external/greencourse/GetCustomerCourseStatus?customersCourseId=${customersCourseId}`, null)
}
